import { toast } from "react-toastify";
import { useFetchUserAccessedProjectsQuery,} from "../../slice/logdetailSlice";
import { Controller, useForm } from "react-hook-form";
import { useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { IoIosArrowBack } from "react-icons/io";
import FileUpload, { SingleFileUpload } from "./FileUpload";
import { addDocument, createEntity } from "../../apis/apiService";
import { Autocomplete, Checkbox, TextField } from "@mui/material";
import { BtnLoader } from "./Loader";

const ImportTimesheet = ({
  onApply,
  onClear,
  onCancel,
  onDocumentAdded,
  project_id,
  refetchList,
  type,
  isModule,
  importPath,
}) => {
  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      uploadedFile: null,
    },
  });

  const [uploadedFile, setUploadedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  //  const { id } = useParams();
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const { data: user_accessed_project } = useFetchUserAccessedProjectsQuery();

  //console.log("user_accessed_project :", user_accessed_project);
  const onSubmit = async (data) => {
    setLoading(true);
    // const finalData = { ...data, uploadedFile };
    if (!uploadedFile) {
      // console.error("Please upload a file before submitting.");
      toast.error("Please upload a file before submitting.");
      return;
    }
    const formData = new FormData();
    formData.append("file", uploadedFile);
    if (isModule) {
      formData.append("project_id", selectedProjectId);
    } 
    else {
      formData.append("project_id", project_id);
    }

    try {
      // const requestedData = {
      //   file: uploadedFile,
      //   project_id: selectedProjectId,
      // };
      const response = await createEntity(importPath, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success(response.message || "Document successfully uploaded!");
      refetchList();
      reset();
      setUploadedFile(null); // Clear the uploaded file
      onCancel();
      // setUploadSuccess(true);
      if (onDocumentAdded) {
        onDocumentAdded();
      }
    } 
    catch (error) {
      // console.error('Failed to upload document:', error);
      toast.error(error.message || "Failed to upload document");
    } 
    finally {
      setLoading(false);
    }
  };
  //console.log("uploadedFile_length", uploadedFile);

  return (
    <div className="">
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack />
            Upload Document
          </div>
        </button>
      </div>
       
      <div className="bg-white px-4 py-3">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            {isModule ? (
              <>
                <div className="col-md-12 my-3">
                  <label htmlFor="project_id" className="form-label">
                    Project Name <span className="errorMsg">*</span>
                  </label>
                  <Controller
                    name="project_id"
                    control={control}
                    rules={{ required: "Project field is required" }}
                    render={({
                      field: { onChange, value },
                      formState: { errors },
                    }) => (
                      <>
                        <Autocomplete
                          id="project_id"
                          options={
                            Array.isArray(user_accessed_project)
                              ? user_accessed_project
                              : []
                          }
                          getOptionLabel={(option) => option?.title}
                          value={
                            user_accessed_project?.find(
                              (user) => user?.project_id === value
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            if (newValue) {
                              if (Array?.isArray(newValue)) {
                                toast.error("You can select only one project.");
                              } else {
                                onChange(newValue?.project_id);
                                setSelectedProjectId(newValue?.project_id); // Set selected user ID
                              }
                            } else {
                              onChange(null);
                              setSelectedProjectId(null); // Reset selected user ID
                            }
                          }}
                          renderOption={(props, option, { selected }) => (
                            <li
                              {...props}
                              className="d-flex align-items-center mb-2"
                            >
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              <strong>{option.title}</strong>
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select project"
                            />
                          )}
                        />
                        <span className="errorMsg">
                          {errors?.project_id?.message}
                        </span>
                      </>
                    )}
                  />
                </div>

                {selectedProjectId && (
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <label htmlFor="Upload File" className="form-label">
                        Upload File <span className="errorMsg">*</span>
                      </label>
                      <SingleFileUpload
                        onFileChange={(file) => setUploadedFile(file)}
                      />
                    </div>
                  </div>
                )}
              </>
            ) : (
              <>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="Upload File" className="form-label">
                      Upload File <span className="errorMsg">*</span>
                    </label>
                    <SingleFileUpload
                      onFileChange={(file) => setUploadedFile(file)}
                    />
                  </div>
                </div>
              </>
            )}
            <div>
              
              <div className="bg-white my-4">
                <div className="d-flex justify-content-left mt-3">
                  <button
                    type="submit"
                    className="add_btn me-3"
                    disabled={uploadedFile === null || loading}
                  >
                    {loading ? (
                      <>
                        <BtnLoader />
                      </>
                    ) : (
                      "Upload"
                    )}
                  </button>
                  <button
                    type="button"
                    className="cancel_btn"
                    onClick={onCancel}
                    disabled={loading}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};

export default ImportTimesheet;
